import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Form } from 'ui-base';
import { RadioButton } from './RadioButton';
import styles from './Radio.module.scss';
import { createChainedFunction } from '../../utils';

const { Control } = Form;

class RadioGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || props.defaultValue
    };
  }

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.value) {
      return {
        value: nextProps.value
      };
    }
    return null;
  }

  onChange = event => {
    this.setState({
      value: event.target.value,
    });

    const { onChange } = this.props;
    if (onChange) onChange(event);
  };

  renderRadioButtons = () => {
    const { name, options, children, disabled } = this.props;

    if (options && options.length) {
      return options.map(item => (
        <RadioButton
          id={`${name}-${item.value}`}
          name={name}
          key={`${name}-${item.value}`}
          value={item.value}
          disabled={disabled || item.disabled}
          checked={item.value === this.state.value}
          onChange={this.onChange}
        >
          {item.label}
        </RadioButton>
      ));
    }

    return React.Children.map(children, child => React.cloneElement(child, {
      ...child.props,
      id: `${name}-${child.props.value}`,
      key: `${name}-${child.props.value}`,
      name: name || child.props.name,
      disabled: disabled || child.props.disabled,
      checked: child.props.value === this.state.value,
      onChange: createChainedFunction(child.props.onChange, this.onChange)
    }));
  };

  render = () => (
    <Control className={classnames(styles.radioGroup, this.props.className)}>
      {this.renderRadioButtons()}
    </Control>
  )
}

RadioGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.string,
  defaultValue: PropTypes.string
};

RadioGroup.defaultProps = {
  children: null,
  className: null,
  disabled: false,
  onChange: null,
  options: [],
  value: null,
  defaultValue: null
};

export { RadioGroup };
